import http from "./httpService";
import config from "./config.json";

export const registerUser = (user: any) => {
    return http.post(`${config.bestlearnapi}/auth/register`, JSON.stringify(user));
};

export const loginUser = (user: any) => {
    return http.post(`${config.bestlearnapi}/auth/login`, JSON.stringify(user));
};
